{
  "Samsung": {
    "Galaxy A Quantum": [
      "SM-A716S"
    ],
    "Galaxy Quantum2": [
      "SM-A826S"
    ],
    "Galaxy Quantum3": [
      "SM-M536S"
    ],
    "Galaxy Quantum4": [
      "SM-A546S"
    ],
    "Galaxy Quantum5": [
      "SM-A556S"
    ],
    "Galaxy Quantum6": [
      "SM-A566S"
    ],
    "Galaxy Wide4": [
      "SM-A205S"
    ],
    "Galaxy Wide5": [
      "SM-E426S",
      "SM-F426S"
    ],
    "Galaxy Wide6": [
      "SM-A136S"
    ],
    "Galaxy Wide7": [
      "SM-M156S"
    ],
    "Galaxy Wide8": [
      "SM-M166S"
    ],
    "Galaxy Wide9": [
      "SM-M176S"
    ],
    "Galaxy Jump": [
      "SM-A326K"
    ],
    "Galaxy Jump2": [
      "SM-M336K"
    ],
    "Galaxy Jump3": [
      "SM-M446K"
    ],
    "Galaxy Jump4": [
      "SM-M366K"
    ],
    "Galaxy Buddy": [
      "SM-A226L"
    ],
    "Galaxy Buddy2": [
      "SM-M236L"
    ],
    "Galaxy Buddy3": [
      "SM-A156L"
    ],
    "Galaxy Buddy4": [
      "SM-A166L"
    ]
  }
}